<template>
  <b-form-group class="mb-5" label-cols="4" label-cols-lg="2" label-class="font-weight-bold" :label="label ? label : 'Filter:' " label-for="select-filter">
    <b-form-select
      id="select-filter"
      v-model="selected"
      :options="[{ value: '*', text: 'Show all' }].concat(options.map(option => ({ value: option, text: option })))"
      @change="onChange"
    />
  </b-form-group>
</template>

<script>
export default {
  name: 'MioFilters',
  props: {
    label: String,
    options: Array,
  },
  data() {
    return {
      selected: '*',
    }
  },
  methods: {
    onChange(event) {
      let filterableElements = document.querySelectorAll('[data-filter]');
      if (event === '*') {
        for (let element of filterableElements) {
          element.classList.remove('d-none');
        }
      } else {
        for (let element of filterableElements) {
          if (element.dataset.filter === event) {
            element.classList.remove('d-none');
          } else if (this.options.includes(element.dataset.filter)) {
            element.classList.add('d-none');
          }
        }
      }
    }
  },
}
</script>
